import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import BlogSection from "./components/BlogSection";
import AboutSection from "./components/AboutSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://superbuy.sbs';

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Superbuy Spreadsheet",
    "url": siteUrl,
    "description": "Discover the best superbuy spreadsheet with curated finds, trusted seller ratings, buying guides, safety tips, and comparison tables.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${siteUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Superbuy Spreadsheet",
    "url": siteUrl,
    "description": "Your ultimate resource for curated superbuy spreadsheet finds, trusted seller ratings, buying guides, and safety tips for smarter online shopping.",
    "sameAs": [
      "https://kaspreadsheet.com/"
    ]
  }
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="Best Superbuy Spreadsheet 2026 | Curated Finds, Guides & Safety"
        description="Discover the best superbuy spreadsheet with curated finds, trusted seller ratings, buying guides, safety tips, and comparison tables. Your ultimate resource for smarter online shopping in 2026."
        keywords="superbuy spreadsheet, best superbuy spreadsheet, superbuy finds, superbuy guide, superbuy safety, buying guide, product comparison"
        canonicalPath="/"
        ogType="website"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection limit={14} />
        <BlogSection />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}